import { useContext } from "react";
import { GlobalContext, GlobalContextType } from "./GlobalContextProvider";

export function usePlugTypeContext() {
  const { plugTypes } = useContext<GlobalContextType>(GlobalContext);
  return plugTypes;
}
